<template>
  <KTTable
    title="Áreas Cargos"
    subtitle="Lista de Áreas Cargos"
    :fields="fields"
    :endpoint="endpoint"
    :delete="DELETE_AREA_CARGO"
    @edit="editItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_AREA_CARGO } from "@/core/services/store/areasCargos.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      DELETE_AREA_CARGO,
      endpoint: "dic_mercados",
      fields: [
        {
          key: "id_mercado",
          label: "Código Área Cargo",
          sortable: true
        },
        {
          key: "descripcion",
          label: "Lieral Áreas Cargo",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    editItem(item) {
      this.$router.push(`${this.$route.path}/${item.id_mercado}`);
    }
  }
};
</script>
